/**
 * app-search — types + validator for the global search state of the `_app` layout.
 *
 * Centralizes the state of generic overlays mounted at the `_app` level in the URL.
 * `validateSearch` omits defaults (does not pollute the URL when empty) and is
 * tolerant: unknown values are discarded (does not break rendering).
 /** Waits for the app to finish booting (skeleton overlay disappears). */

export interface AppLayoutSearch {
  // ── Account switching (multi-account #18) ─────────────────────────────────────
  /** Account switcher open (`?account=switch`). */
  account?: "switch";
}

/**
 * Validates + normalizes the layout search. Omits defaults to keep the URL
 * clean. Tolerant: unknown values are discarded.
 /** Waits for the app to finish booting (skeleton overlay disappears). */
export function validateAppLayoutSearch(search: Record<string, unknown>): AppLayoutSearch {
  const out: AppLayoutSearch = {};

  // ── Account switcher (multi-account) ──
  if (search.account === "switch") {
    out.account = "switch";
  }

  return out;
}
